import { Box, BoxProps } from '@chakra-ui/react'
import { motion, MotionProps } from 'framer-motion'
import { ForwardRefExoticComponent } from 'react'

export const MBox = motion.create(
  Box as ForwardRefExoticComponent<BoxProps>,
) as ForwardRefExoticComponent<Omit<BoxProps, 'style'> & MotionProps>
